module.exports = __webpack_public_path__ + "media/tema_2_pstañas_b_patient_CF1.cf76cc7c.wav";